import { noop } from 'lodash';
import { logger, stats } from '@fiverr-private/obs';
import { serialize, Serializers } from '../../../utils/common';

/** @typedef {React.ComponentProps<import('react').FC<import('types/components/common').SafeLazyImportProps>>} SafeLazyImportProps */

/** @type {(params: Pick<SafeLazyImportProps, 'moduleName'|'onLoadError'> & {error: Error}) => void} */
export const logLazyLoadError = ({ moduleName, error, onLoadError = noop }) => {
    logger.warn(`Failed to lazy load ${moduleName}`, { error });
    onLoadError(error);
    stats.count(
        `business_blocks.${serialize(moduleName, Serializers.SnakeCase)}`,
        'lazy_import_failed'
    );
};
